<template>
  <flow-block-container
    @remove="$emit('remove')"
    @change-time="onChangeTime"
    @lock-time="onLockTime"
    @drag-time="onDragTime"
    @drag-time-active="onDragTimeActive"
    :draggablesListVirtualOffsets="draggablesListVirtualOffsets"
    :dragTimeActive="dragTimeActive"
    :show-connection="showConnection"
    :item="value">
    <div class="flow-sequence">
      <div style="display: flex; flex-wrap: nowrap;">
        <div v-if="imageSource" class="dayplanner-flow-item-image" :style="imageStyle">
          <div style="width: 45px; height: 45px"></div>
        </div>
        <div v-else>
          <EditableIcon v-model="item.icon" :is-editable="isEditable"/>
        </div>
        <div style="display: flex; flex-direction: column">
          <div class="flow-sequence-headline">
            <span @click="onGoToCommitment" style="cursor: pointer">{{ item.title }}</span>
          </div>
          <div>
            <duration-quick-settings
              v-model="sessionLength"
              @save="onQuickSetDurationTask"
              v-if="isEditable"
              :showSeconds="false"
              :quickDurationSettings="{
                '0 min': 0 * 60,
                '1 min': 1 * 60,
                '3 min': 3 * 60,
                '5 min': 5 * 60,
                '10 min': 10 * 60,
                '15 min': 15 * 60,
                '20 min': 20 * 60,
                '25 min': 25 * 60,
                '30 min': 30 * 60,
                '45 min': 45 * 60,
                '1 h': 1 * 60 * 60,
                '2 h': 2 * 60 * 60,
                '3 h': 3 * 60 * 60,
                '4 h': 4 * 60 * 60,
                '8 h': 8 * 60 * 60,
              }" />
          </div>
        </div>
      </div>

      <div v-if="commitment.$ready" style="width: 340px; margin-bottom: 0.5em; margin-left: 0.5em">
        <div
          v-for="sequenceItem in sequenceItemList"
          :key="'flow-sequence-' + sequenceItem.sequenceItemId"
          style="display: flex; flex-wrap: nowrap; align-items: center; margin-top: 0.2em; ">
          <div :style="sequenceItemStyle">
            <div style="width: 230px; margin-left: 0.5em;">
              <span v-if="sequenceItem.from" style="font-weight: bold">{{ sequenceItem.from * 1000 | shortTime }} - </span> {{ sequenceItem.title }}
            </div>
            <div style="width: 70px;">{{ sequenceItem.durationInSession | hoursMinutes }}</div>
          </div>
          <div style="margin-left: 0.5em; display: flex; ">
            <!--<el-button
            size="mini"
            @click="onAddItem"
            style="float:right; width: 50px; height: 25px"
          >Add</el-button>-->
          </div>
        </div>
      </div>

      <!-- <pre class="mini-pre">{{sequenceItemList}}</pre> -->

    </div>
  </flow-block-container>
</template>

<script>
import { mapGetters } from "vuex";
import FlowBlockContainer from './FlowBlockContainer'
import EditableIcon from "@/components/RoutineCreatorPage/Elements/EditableIcon";
import DurationQuickSettings from "@/components/Elements/DurationQuickSettings";
import SessionManagementMixin from "@/components/Mixins/SessionManagement"
// import KanbanList from '@/components/GoalPage/Elements/KanbanList';
// import SessionsEffort from "@/components/Sessions/SessionsEffort"

// TODO: Session oder TaskList anzeigen

export default {
  mixins: [SessionManagementMixin],
  props: {
    value: {},
    showConnection: { default: true },
    isEditable: { default: true },
    optimizer_sessions_today: { // TODO: Vuex?
      type: Array
    },
    draggablesListVirtualOffsets: { // TODO: vuex?
      type: Object,
    },
    dragTimeActive: { // TODO: vuex?
      type: Boolean,
    },
    idx: {
      type: Number
    }
  },
  data: () => ({
    item: {},
    timeFrom: null,
    timeTo: null,
  }),
  watch: {
    value: {
      handler(newValue) {
        this.item = newValue;
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    // TODO: Only load relevant tasks instead of entire kanban (with deleted and done)
    this.$models.task.subscribe_to_goal_tasks( this.goalId ).then(() => {
      console.log("******** LOADING DONE **********")
    })
  },
  computed: {
    ...mapGetters("dayplanner", [
      'dayplan_virtual_offsets'
    ]),
    sequenceItemList() {
      return this.value.sequenceItems.map(id => {
        return {
          sequenceItemId: id,
          title: 'TODO: ' + id, // TODO
          // from, // TODO
          // durationInSession // TODO
        }
      })
    },
    sequenceItemStyle() {
      return {
        // TODO: recycle css class
        "background-color": this.value.config.tscColor,
        "border": "1px",
        "color": "#FFFFFF",
        "font-weight": "bold",
        "display": "flex",
        "justify-content": "space-between",
        "border-radius": "5px",
        "min-height": "25px",
        "opacity": 1
      };
    },
    commitmentId() {
      return this.value.config.commitmentId;
    },
    goalId() {
      return this.value.config.goalId;
    },
    commitment() {
      return this.$models.commitment
        .with({ goalId: this.goalId })
        .subscribeNode(this.commitmentId);
    },
    virtualOffsetCurrentSession() {
      return this.dayplan_virtual_offsets[ this.item.sessionId ] || {
        from: 0, to: 0, duration: 0
      };
    },
    imageStyle() {
      return {
        backgroundImage: "url(" + this.imageSource + ")",
        borderColor: this.tscColor //this.session.color
      };
    },
    imageSource() {
      if (this.commitment.$ready) {
        if (this.commitment.picture) {
          return this.commitment.picture;
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
    sessionLength: {
      get() {
        return this.value.to - this.value.from
      },
      set(duration) {
        console.log("blocked set")
        // this.value.to = this.value.from + duration
      }
    }
  },
  methods: {
    onClickSequenceItem() {
      // TODO: See old sessions
    },
    onQuickSetDurationTask(value) {
      console.log("onQuickSetDurationTask", value)

      let timeFrom = this.item.from;
      let timeTo   = this.item.from + value;

      // this.timeFrom = timeFrom;
      // this.timeTo = timeTo;

      this.$emit("change-time", { selection: 'to', timeTo, timeFrom } )
    },
    onChangeTime({ selection, timeTo, timeFrom }) {
      console.log("onChangeTime", selection, timeTo, timeFrom);
      this.$emit("change-time", { selection, timeTo, timeFrom });
    },
    onLockTime({ selection, value }) {
      this.$emit( 'lock-time', { selection, value } )
    },
    onDragTime({ selection, offset }) {
      // console.log("onChangeTime", selection, value);
      this.timeFrom = this.item.from
      this.timeTo = this.item.to + this.virtualOffsetCurrentSession.duration
      this.$emit("drag-time", { selection, offset });
    },
    onDragTimeActive({ value }) {
      console.log("onDragTimeActive flowTasklist", value);
      this.$emit("drag-time-active", { value });
    },
    onGoToCommitment() {
      this.$router.push('/goal/' + this.goalId + '/kanban')
    },
  },
  components: {
    EditableIcon,
    FlowBlockContainer,
    DurationQuickSettings,
    // SessionsEffort,
    //KanbanList,
  }
};
</script>

<style>
/*
.dayplanner-flow-item-image {
  width: 45px;
  height: 45px;
  margin-left: 0.5em;
  margin-right: 0.5em;
  border: 1px solid white;
  cursor: pointer;
  background-position: 50% 25%;
  background-repeat: no-repeat;
  background-size: cover;
}
.dayplanner-flow-item-image img {
  flex-shrink: 0;
  min-width: 100%;
  min-height: 100%;
}
*/
.flow-sequence .lane {
  display: flex;
  justify-content: center;
  padding-top: 0.2em;
  /*padding-bottom: 0.2em;*/
  margin: 0 auto;
}
.flow-sequence .list .list-inner {
  border: none;
  /*border-top: 1px solid #cfcfcf*/
  max-height: unset;
}
.flow-sequence-headline {
  font-weight: bold;
  font-size: 12pt;
  line-height: 1em;
  width: 100%;
  white-space: normal;
  text-overflow: ellipsis;
  -o-text-overflow: hidden;
  display: flex;
  overflow: hidden;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-align: left
}
</style>
